export default __webpack_public_path__ + "static/media/StumpGrinding.21af8008.jpg";